import * as React from 'react';
import ReactPlaceholder from 'react-placeholder';

import { SkeletonLoaderContainer } from './SkeletonLoaderContainer';

export const TicketSkeletonLoader = ({ rows }: { rows: number }) => {
  const Skeleton = () => (
    <div className="ticket">
      <div className="ticket-header">
        <div className="ticket-header-text-container">
          <h4 className="display-name">
            <ReactPlaceholder type="text" showLoadingAnimation ready={false} rows={1} color="#E0E0E0">
              <div />
            </ReactPlaceholder>
          </h4>
        </div>
      </div>
      <div className="ticket-body">
        <div className="ticket-left">
          <ReactPlaceholder type="text" showLoadingAnimation ready={false} style={{ marginLeft: '10px' }} rows={3} color="#E0E0E0">
            <div />
          </ReactPlaceholder>
        </div>
      </div>
    </div>
  );
  return (
    <SkeletonLoaderContainer>
      {[...Array(rows)].map(() => (
        <Skeleton />
      ))}
    </SkeletonLoaderContainer>
  );
};
